import { Statistic, StatisticProps } from 'antd'
import React, { FC } from 'react'
import CountUp from 'react-countup'

import { StatDisplayContainer } from './AbstractStatDisplay'

export interface StatDisplayCountProps {
  isLoading?: boolean
  title: string
  count: number
}

const formatter: StatisticProps['formatter'] = (value) => (
  <CountUp duration={1} end={value as number} separator=',' />
)

export const StatDisplayCount: FC<StatDisplayCountProps> = ({
  title,
  count,
  isLoading,
}) => {
  return (
    <StatDisplayContainer title={title} isLoading={isLoading ?? false}>
      <Statistic value={count} formatter={formatter} />
    </StatDisplayContainer>
  )
}
